import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    onlineSessionsListLoading: false,
    onlineSessionsList: {},
    onlineSessionsListError: null,
    bannerDetailsLoading: false,
    bannerDetails: {},
    bannerDetailsError: "",
    onlineSessionByIdLoading: false,
    onlineSessionByIdSuccess: {},
    onlineSessionByIdError: ""
}

export const onlineSessionSlice = createSlice({
    name: 'onlineSession',
    initialState,
    reducers: {
        getOnlineSessionsListLoading: (state, action) => {
            state.onlineSessionsListLoading = true
        },
        getOnlineSessionsListSuccess: (state, action) => {
            state.onlineSessionsListLoading = false
            state.onlineSessionsList = action.payload
        },
        getOnlineSessionsListError: (state, action) => {
            state.onlineSessionsListLoading = false
            state.onlineSessionsList = {}
            state.onlineSessionsListError = action?.payload?.message
        },
        getOnlineSessionByIdLoading: (state, action) => {
            state.onlineSessionByIdLoading = true
        },
        getOnlineSessionByIdSuccess: (state, action) => {
            state.onlineSessionByIdLoading = false
            state.onlineSessionByIdSuccess = action.payload.data
            state.onlineSessionByIdError = ""
        },
        getOnlineSessionByIdError: (state, action) => {
            state.onlineSessionByIdLoading = false
            state.onlineSessionByIdSuccess = {}
            state.onlineSessionByIdError = action.payload.message
        },
        resetOnlineSessionrDetails: (state, action) => {
            state.onlineSessionByIdLoading = false
            state.onlineSessionByIdSuccess = {}
        }
    },
})

// Action creators are generated for each case reducer function
export const {
    getOnlineSessionsListLoading,
    getOnlineSessionsListSuccess,
    getOnlineSessionsListError,
    getOnlineSessionByIdLoading,
    getOnlineSessionByIdSuccess,
    getOnlineSessionByIdError,
    resetOnlineSessionrDetails

} = onlineSessionSlice.actions

export default onlineSessionSlice.reducer;